import PromptEyebrow from './PromptEyebrow.jsx';

/**
 * Eyebrow — section label. Now renders the terminal-prompt style via
 * PromptEyebrow (mono `>` prompt, CRT scanlines, blinking caret).
 * API preserved so all existing call sites keep working.
 */
export default function Eyebrow({ tone = 'default', as = 'span', className = '', children }) {
  return (
    <PromptEyebrow tone={tone} as={as} className={className}>
      {children}
    </PromptEyebrow>
  );
}
